import { createLibraryQueue } from "../../../shared/libraryQueue.js";
import {
  bridgeLibraryRequest,
  observeLibraryResponse,
} from "../../../shared/libraryBridge.js";
let token = null,
  queue = null;
const listeners = new Set();
export const subscribeLibrarySync = (fn) => {
  listeners.add(fn);
  return () => listeners.delete(fn);
};
const changed = () => {
  for (const fn of listeners) fn();
};
const accountFor = (value) => {
  try {
    return JSON.parse(
      atob(value.split(".")[1].replace(/-/g, "+").replace(/_/g, "/")),
    ).id;
  } catch {
    return null;
  }
};
export function getLibraryQueue(raw) {
  const next = localStorage.getItem("polka_token");
  if (next === token && queue) return queue;
  token = next;
  const account = next && accountFor(next);
  queue = null;
  if (!account) return null;
  const captured = next,
    key = `polka_outbox_${account}`;
  queue = createLibraryQueue({
    userId: account,
    read: () => JSON.parse(localStorage.getItem(key) || "[]"),
    write: (entries) => {
      try {
        localStorage.setItem(key, JSON.stringify(entries));
        return true;
      } catch {
        return false;
      }
    },
    send: (op) => {
      if (localStorage.getItem("polka_token") !== captured)
        throw Object.assign(Error("Аккаунт изменился"), { status: 401 });
      return raw("/library-sync", { method: "POST", body: JSON.stringify(op) });
    },
    isActive: () => localStorage.getItem("polka_token") === captured,
    onChange: changed,
  });
  // Seed preconditions from the account's existing offline snapshots.
  for (const kind of ["shelf", "wishlist"]) {
    try {
      const data = JSON.parse(
        localStorage.getItem(`polka_offline_${kind}_${account}`) || "null",
      )?.data;
      if (Array.isArray(data)) queue.observe(kind, data);
    } catch {
      /* An optional old read cache may be absent. */
    }
  }
  return queue;
}
export async function libraryRequest(path, options, raw) {
  const q = getLibraryQueue(raw);
  if (!q) return { handled: false };
  return bridgeLibraryRequest(
    q,
    path,
    (options.method || "GET").toUpperCase(),
    options.body ? JSON.parse(options.body) : {},
    (path, options) => raw(path, options),
  );
}
export async function libraryResponse(path, value, raw, ticket) {
  const q = getLibraryQueue(raw);
  await q?.ready;
  return q && q === ticket?.queue
    ? observeLibraryResponse(q, path, value, ticket.revision)
    : value;
}

export async function libraryReadTicket(raw) {
  const q = await getLibraryQueue(raw);
  await q?.ready;
  return q ? { queue: q, revision: q.getState().revision } : undefined;
}
